"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
var ImportTaskStatus;
(function (ImportTaskStatus) {
    ImportTaskStatus["Requested"] = "REQUESTED";
    ImportTaskStatus["Checking"] = "CHECKING";
    ImportTaskStatus["Importing"] = "IMPORTING";
    ImportTaskStatus["Finished"] = "FINISHED";
    ImportTaskStatus["Error"] = "ERROR"; // ImportTasker has finished with errors
})(ImportTaskStatus = exports.ImportTaskStatus || (exports.ImportTaskStatus = {}));
var ImportTaskType;
(function (ImportTaskType) {
    ImportTaskType["ProductCSV"] = "PRODUCT_CSV";
    ImportTaskType["ProductSFTP"] = "PRODUCT_SFTP";
    ImportTaskType["CustomersCSV"] = "CUSTOMER_CSV";
})(ImportTaskType = exports.ImportTaskType || (exports.ImportTaskType = {}));
class ImportTask extends Parse.Object {
    constructor(attributes) {
        super('ImportTask', attributes);
    }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get type() { return this.get('type'); }
    set type(value) { this.set('type', value); }
    get status() { return this.get('status'); }
    set status(value) { this.set('status', value); }
    get file() { return this.get('file'); }
    set file(value) { this.set('file', value); }
    get progressCounters() { return this.get('progressCounters'); }
    set progressCounters(value) { this.set('progressCounters', value); }
    get errors() { return this.get('errors'); }
    set errors(value) { this.set('errors', value); }
    // Only present with status === ImportTaskStatus.Error
    get errorMessage() { return this.get('errorMessage'); }
    set errorMessage(value) { this.set('errorMessage', value); }
    // To be used to pass import options to the import component
    get options() { return this.get('options'); }
    set options(value) { this.set('options', value); }
    get sftpS3Key() { return this.get('sftpS3Key'); }
    set sftpS3Key(value) { this.set('sftpS3Key', value); }
}
exports.ImportTask = ImportTask;
Parse.Object.registerSubclass('ImportTask', ImportTask);
//# sourceMappingURL=ImportTask.js.map